import dayjs from 'dayjs';

const roundQty = (value = 0) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const getDepositTypeLabel = (type) => {
    const labels = {
        centrale: 'Deposito centrale',
        sede: 'Sede',
        tecnico: 'Deposito tecnico',
        contovisione: 'Contovisione',
        virtuale: 'Deposito virtuale',
        laboratorio: 'Laboratorio',
    };

    return labels[type] || type;
};

export const getSerialStatusColor = (status) => {
    const colors = {
        disponibile: 'success',
        in_prova: 'processing',
        venduto: 'blue',
        reso: 'default',
        in_trasferimento: 'gold',
    };

    return colors[status] || 'default';
};

export const getSerialStatusLabel = (status) => {
    const labels = {
        disponibile: 'Disponibile',
        in_prova: 'In prova',
        venduto: 'Venduto',
        reso: 'Reso',
        in_trasferimento: 'In trasferimento',
    };

    return labels[status] || status;
};

const buildArticleStock = (articles = [], serials = [], consumptions = []) => {
    return articles.map((article) => {
        const articleSerials = serials.filter((serial) => serial.articleCode === article.code);
        const serialStock = articleSerials.filter((serial) => serial.status !== 'venduto' && serial.status !== 'reso').length;
        const consumedQty = consumptions
            .filter((consumption) => consumption.articleCode === article.code)
            .reduce((sum, consumption) => sum + Number(consumption.quantity || 0), 0);
        const effectiveQty = roundQty(serialStock - consumedQty);

        return {
            ...article,
            effectiveQty,
            belowThreshold: effectiveQty <= Number(article.minStock || 0),
        };
    });
};

const buildDepositSummaries = (deposits = [], serials = [], consumptions = []) => {
    return deposits.map((deposit) => {
        const depositSerials = serials.filter((serial) => serial.currentDepositId === deposit.id && serial.status !== 'venduto' && serial.status !== 'reso');
        const consumedQty = consumptions
            .filter((consumption) => consumption.depositId === deposit.id)
            .reduce((sum, consumption) => sum + Number(consumption.quantity || 0), 0);

        return {
            ...deposit,
            serialCount: depositSerials.length,
            consumedQty: roundQty(consumedQty),
        };
    });
};

const buildPendingTrials = (serials = []) => {
    const today = dayjs();

    return serials
        .filter((serial) => serial.status === 'in_prova' && serial.trialStartedAt)
        .map((serial) => {
            const trialDays = today.diff(dayjs(serial.trialStartedAt), 'day');
            return {
                ...serial,
                trialDays,
                overdue: trialDays > 30,
            };
        })
        .sort((left, right) => right.trialDays - left.trialDays);
};

export const recalculateInventoryWorkspace = ({ inventoryWorkspace = {} }) => {
    const nextWorkspace = {
        ...inventoryWorkspace,
        articles: [...(inventoryWorkspace.articles || [])],
        deposits: [...(inventoryWorkspace.deposits || [])],
        serials: [...(inventoryWorkspace.serials || [])],
        transfers: [...(inventoryWorkspace.transfers || [])],
        consumptions: [...(inventoryWorkspace.consumptions || [])],
        reorderProposals: [...(inventoryWorkspace.reorderProposals || [])],
    };

    nextWorkspace.articleStock = buildArticleStock(nextWorkspace.articles, nextWorkspace.serials, nextWorkspace.consumptions);
    nextWorkspace.depositSummaries = buildDepositSummaries(nextWorkspace.deposits, nextWorkspace.serials, nextWorkspace.consumptions);
    nextWorkspace.pendingTrials = buildPendingTrials(nextWorkspace.serials);
    nextWorkspace.lowStockAlerts = nextWorkspace.articleStock.filter((article) => article.belowThreshold);
    nextWorkspace.obsoleteArticles = nextWorkspace.articleStock.filter((article) => article.obsolete);
    nextWorkspace.summary = {
        activeSerials: nextWorkspace.serials.filter((serial) => serial.status !== 'venduto' && serial.status !== 'reso').length,
        deposits: nextWorkspace.deposits.length,
        lowStock: nextWorkspace.lowStockAlerts.length,
        pendingTrialsOver30: nextWorkspace.pendingTrials.filter((serial) => serial.overdue).length,
    };

    return nextWorkspace;
};
